import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { BaseClass } from '../../utility/baseClass';
import { EsignhomeService } from '../../main-layout/esignhome/esignhome.service';

@Component({
  selector: 'app-esignhomemodal',
  templateUrl: './esignhomemodal.component.html',
  styleUrls: ['./esignhomemodal.component.css']
})
export class EsignhomemodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  requestform: FormGroup;
  existingdetails: any = {};
  esignForm: FormGroup
  EsignDetails: any = {}
  EsignotherDetails: any = {}

  public validation_message = {}
  tempentity: any;

  constructor(
    private esignService: EsignhomeService,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef,
    public dialogService: DialogService,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private spinnerservice: NgxSpinnerService
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    this.EsignDetails = dataFromParent.datas.esigndata;
    this.EsignotherDetails = dataFromParent.datas.esigndetails;
  }

  ngOnInit() {
    this.formInitiliaze();
    this.patchValueForms(this.EsignDetails)
  }

  patchValueForms(data) {
    this.esignForm.patchValue({ 'module': data[0].productname });
    this.esignForm.patchValue({ 'esignid': data[0].rid });
    this.esignForm.patchValue({ 'transid': data[0].transid });
    this.esignForm.patchValue({ 'uuid': data[0].uuid });
    this.esignForm.patchValue({ 'createdon': data[0].createdon });
    this.esignForm.patchValue({ 'createdby': data[0].nam });
    this.esignForm.patchValue({ 'doctype': data[0].documenttype });
    this.esignForm.patchValue({ 'signtype': data[0].signtype });
    this.esignForm.patchValue({ 'signseq': data[0].signsequence });
    this.esignForm.patchValue({ 'signpage': data[0].pageofsign });
    this.esignForm.patchValue({ 'numberofsigns': data[0].numberofsigns });
    this.esignForm.patchValue({ 'ctr': data[0].ctr });
    this.esignForm.patchValue({ 'closeddate': data[0].closeddate });
    this.esignForm.patchValue({ 'pdffilename': data[0].pdffilename });
    this.esignForm.patchValue({ 'finals3signeddocument': data[0].finals3signeddocument });

  };


  dismiss() {
    Swal.fire({
      title: "Are you sure to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }

  formInitiliaze() {
    this.esignForm = this.fb.group({
      module: [""],
      esignid: [""],
      transid: [""],
      uuid: [""],
      createdon: [""],
      createdby: [""],
      doctype: [""],
      signtype: [""],
      signseq: [""],
      signpage: [""],
      numberofsigns: [""],
      ctr: [""],
      closeddate: [""],
      pdffilename: [""],
      finals3signeddocument: [""]
    });
  }

  viewData(data) {
    this.esignService.getESignById(data.id).subscribe(res => {
      this.ref = this.dialogService.open(EsignhomemodalComponent, {
        header: 'View ESignature Information',
        height: '100%',
        width: "98%",
        data: { title: 'View ESignature', datas: res },
        // contentStyle: { overflow: 'hidden'  },
        baseZIndex: 10000,
        maximizable: true,
      });
    }, error => {
      const timestamp = new Date().toLocaleString();
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      })
    })
  }

  gettoken() {
    this.CSRFToken = '';
    this.esignService.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}
